import subscribeSaga from './subscribeSaga';
import consumerReducer from './reducer';
import { reduxModuleLoaded } from './actions';
import { tierConsumerReduxKey } from './constants';
export function getModule() {
    var _a;
    return {
        id: 'tierConsumer',
        reducerMap: (_a = {},
            _a[tierConsumerReduxKey] = consumerReducer,
            _a),
        sagas: [subscribeSaga],
        initialActions: [reduxModuleLoaded()],
        retained: true,
    };
}
//# sourceMappingURL=module.js.map